/**
 *
 * @param text Text to be redacted
 * @param visibleChars Number of characters to remain visible at the end of the text
 * @param maskedCharsLength Optional length of the masked part; if not provided, it will be calculated based on the text length and visibleChars
 * @returns Redacted text with visible characters at the end
 * @example
 * redactText('721644852') // returns '*****4852'
 * redactText('721644852', 2) // returns '*******52'
 * redactText('721644852', 2, 3) // returns '***52'
 */
export const redactText = (
    text: string,
    visibleChars = 4,
    maskedCharsLength?: number,
): string => {
    if (text.length <= visibleChars) {
        return '*'.repeat(maskedCharsLength ?? text.length);
    }

    const redactedLength = text.length - visibleChars;
    return (
        '*'.repeat(maskedCharsLength ?? redactedLength) +
        text.slice(-visibleChars)
    );
};

/**
 * Opinionated redaction for phone numbers. Keeps only last 2 digits visible.
 */
export const redactPhone = (phone: string): string => {
    return redactText(phone, 2, 3);
};

/**
 * Redacts all but last 5 characters, e.g. "****-abcd"
 */
export const redactUphealerLink = (uphealerLink: string): string =>
    redactText(uphealerLink, 5);
